import { Outlet } from "react-router-dom";
import { ClaimBasedComponent } from "components/ClaimBasedComponent";
import { ClaimResource } from "types/claimTypes";

type ProtectedOutletProps = {
  claims?: ClaimResource[];
};

const ProtectedOutlet = ({ claims = [] }: ProtectedOutletProps) => {
  if (claims.length === 0) {
    return <Outlet />;
  }

  return (
    <ClaimBasedComponent requestedClaims={claims}>
      <Outlet />
    </ClaimBasedComponent>
  );
};

export default ProtectedOutlet;
